import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { ROUTESLIST } from "@/static/urls";

const PrivateRoute = ({ component: Component, children, ...rest }) => {
  const authToken = localStorage.getItem("access_token") || localStorage.getItem("token");

  let isGuest = false;
  try {
    const raw = localStorage.getItem("userInfo");
    if (raw) {
      const userInfo = JSON.parse(raw);
      isGuest = !!userInfo?.isGuest;
    }
  } catch (_) {
    isGuest = false;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authToken) return <Redirect to="/login" />;
        if (
          isGuest &&
          props.location.pathname !== ROUTESLIST.ACCOUNT_CHANGE_PASSWORD
        ) {
          return <Redirect to={ROUTESLIST.ACCOUNT_CHANGE_PASSWORD} />;
        }
        return Component ? <Component {...props} /> : children;
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(PrivateRoute);
